export const environment = {
    production: true,
    apiUrl: 'https://demo.smartworkar.com:8888',
    frontUrl: '',
    urlAssets: 'http://localhost:4200',
    urlBack: 'https://visualizacion-generica-back.candoit.com.ar',
    //urlBack: 'http://localhost:8085',
    user: {
        username: "api_client@smartworkar.com",
        password: "$nSxb$PW7E"
    },
    userApi: {
        username: "a",
        password: "a"
    },
    protocolName: ''


};